
import { provideTransloco, Translation, TranslocoLoader } from '@jsverse/transloco';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

export function provideTranslocoConfig() {
  return provideTransloco({
    config: {
      availableLangs: ['en', 'de'],
      defaultLang: 'de',
      fallbackLang: 'en',
      reRenderOnLangChange: true,
      prodMode: environment.production,
    },
    loader: TranslocoHttpLoader
  });
}


@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}